export default __webpack_public_path__ + "static/app-screen-3-5311d381dd1534ad44af926a43d9231c.png";